/**
 * Raqamni uch xonali guruhlarga ajratib ko'rsatadi: 1234567 -> "1 234 567".
 *
 * RAQAM berilsa kasr qismi ikki xonagacha qisqartiriladi. Sababi: kompyuterda
 * kasrli ko'paytirish aniq natija bermaydi — masalan 19.99 * 7 amali
 * 139.92999999999998 beradi. Eski variant uni jadvalda
 * "139.92 999 999 999 998" ko'rinishida chiqarardi, chunki bo'sh joy qo'yish
 * qoidasi kasr qismiga ham tegib ketardi.
 *
 * MATN berilsa qisqartirilmaydi, faqat guruhlarga ajratiladi. Bu maydonga
 * qo'lda kiritilayotgan qiymat uchun muhim: foydalanuvchi "1." deb yozganda
 * uni "1" ga aylantirib yuborsak, kasr qismini umuman kiritib bo'lmasdi.
 *
 * Bu faqat KO'RSATISH uchun. Hisob-kitobda aniq qiymatlar ishlatiladi.
 */
export const numberWithSpaces = (x: string | number) => {
  const text =
    typeof x === "number" && Number.isFinite(x)
      ? String(Math.round(x * 100) / 100)
      : x?.toString()
  return text?.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}
